module.exports = require("./../../_gen/starling/core/Starling");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/core/Starling.js
// module id = 158
// module chunks = 0